import * as React from 'react';
import Slim, { ISlimConfig, ISlimData } from 'slim';
import 'slim/slim.css';

// Style
import './SlimCropper.css';

// Declarations
export { ISlimData };

// Component
export interface IProps extends ISlimConfig {
    initialImage?: string | null;
    cropperSize?: { height: number, width: number };
    style?: React.CSSProperties;
}
class SlimCropper extends React.Component<IProps, {}> {

    instance: Slim;
    ref: HTMLDivElement;

    handleRef = (ref: HTMLDivElement) => {
        this.ref = ref!;
    }

    componentDidMount() {
        if (this.props.initialImage) {
            let img = document.createElement('img');
            img.setAttribute('alt', '');
            img.src = this.props.initialImage;
            this.ref.appendChild(img);
        }
        this.instance = new Slim(this.ref, this.props);
    }

    componentWillUnmount() {
        this.instance.destroy();
    }

    render() {
        return (
            <div
                ref={this.handleRef}
                className="SlimCropper SlimCropper--rounded slim"
                style={this.props.style}
            >
                <input type="file" accept="image/jpeg"/>
            </div>
        );
    }

}

export default SlimCropper;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SlimCropper/SlimCropper.tsx